<template lang="pug">
.cp-page-belt
  .join-us(:class="info[beltType].bgClass")
    p {{ info[beltType].title }}
    //- a.btn(@click="showModal") {{ info[beltType].btnText }}
</template>
<script>
export default {
  components: {},
  props: {
    beltType: {
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      info: [
        { title: '加入合作伙伴计划，探索人工智能生态新方向', btnText: '申请试用', bgClass: 'bg1' },
        { title: '加入合作伙伴计划，探索人工智能生态新方向', btnText: '申请试用', bgClass: 'bg2' },
        { title: '马上制定您的专属解决方案', btnText: '立即制定', bgClass: 'bg3' },
      ]
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
.cp-page-belt
  .bg1
    background url('../assets/partner-belt.png') bottom / 100% no-repeat
  .bg2
    background url('../assets/chanpin-belt.jpg') bottom / 100% no-repeat
  .bg3
    background url('../assets/hangye-belt.png') bottom / 100% no-repeat
  .join-us
    height 300px
    display flex
    align-items center
    justify-content center
    p
      font-size 36px
      text-align center
      text-shadow 0px 2px 4px rgba(6,25,50,0.89)
    .btn
      display block
      width 166px
      height 50px
      border-radius 5px
      border 2px solid rgba(255,255,255,1)
      font-size 20px
      color #FFF
      display flex
      justify-content center
      align-items center
      cursor pointer
      transition all .3s
      &:hover
        background rgba(255,255,255,.4)
</style>
